export default [
  {
    path: "/translate",
    name: "Translate",
    component: () => import("@/views/Page/Translate/Trans.vue"),
    meta: {
      title: "Translate",
    },
  },
];